import React from 'react';
import { Link } from 'react-router-dom';
import { 
  Utensils, 
  Download, 
  Timer,
  Scale,
  Users,
  Clock,
  Tag,
  MoreVertical,
  Star
} from 'lucide-react';

const RecipeCard = ({ recipe, onDownload }) => {
  const getCategoryColor = (category) => {
    switch (category.toLowerCase()) {
      case 'pizza': return 'blue';
      case 'sandwiches': return 'green';
      case 'appetizers': return 'amber';
      case 'salads': return 'emerald';
      case 'desserts': return 'pink';
      case 'beverages': return 'purple';
      default: return 'gray';
    }
  };

  const color = getCategoryColor(recipe.category);

  return (
    <div className="bg-white rounded-lg shadow-sm hover:shadow-md transition-all overflow-hidden border border-gray-100">
      <div className={`h-2 bg-gradient-to-r from-${color}-500 to-${color}-600`} />
      
      <div className="p-5">
        <div className="flex justify-between items-start mb-4">
          <div className="flex items-center gap-3">
            <div className={`p-2 rounded-lg bg-${color}-50`}>
              <Utensils className={`w-5 h-5 text-${color}-600`} />
            </div>
            <div>
              <h3 className="font-semibold text-gray-900">{recipe.title}</h3>
              <div className="flex items-center gap-2 mt-1">
                <Tag className="w-3.5 h-3.5 text-gray-400" />
                <span className="text-sm text-gray-500">{recipe.category}</span>
              </div>
            </div>
          </div>
          <button className="p-1.5 hover:bg-gray-50 rounded-lg transition-colors">
            <MoreVertical className="w-5 h-5 text-gray-400" />
          </button>
        </div>

        <div className="grid grid-cols-2 gap-4 mb-4">
          <div className="flex items-center gap-2 p-3 bg-gray-50 rounded-lg">
            <Timer className="w-4 h-4 text-gray-400" />
            <div>
              <div className="text-sm font-medium text-gray-900">{recipe.prepTime}</div>
              <div className="text-xs text-gray-500">Prep Time</div>
            </div>
          </div>
          <div className="flex items-center gap-2 p-3 bg-gray-50 rounded-lg">
            <Scale className="w-4 h-4 text-gray-400" />
            <div>
              <div className="text-sm font-medium text-gray-900">{recipe.yield}</div>
              <div className="text-xs text-gray-500">Yield</div>
            </div>
          </div>
        </div>

        <div className="flex items-center justify-between text-sm text-gray-500 mb-4">
          <div className="flex items-center gap-1.5">
            <Users className="w-4 h-4" />
            <span>Used in {recipe.usedIn.length} locations</span>
          </div>
          <div className="flex items-center gap-1.5">
            <Clock className="w-4 h-4" />
            <span>{recipe.lastUpdated}</span>
          </div>
        </div>

        <div className="flex items-center justify-between pt-4 border-t">
          <div className="flex gap-2">
            <button
              onClick={() => onDownload(recipe)}
              className="p-2 text-gray-600 hover:bg-gray-50 rounded-lg transition-colors"
              title="Download PDF"
            >
              <Download className="w-4 h-4" />
            </button>
            <button
              className="p-2 text-gray-600 hover:bg-gray-50 rounded-lg transition-colors"
              title="Add to Favorites"
            >
              <Star className="w-4 h-4" />
            </button>
          </div>
          <Link
            to={`/sop/recipes/${recipe.id}`}
            className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 text-sm font-medium"
          >
            View Recipe
          </Link>
        </div>
      </div>
    </div>
  );
};

export default RecipeCard; 